module.exports = __webpack_public_path__ + "public/adminIcons/searchSetting.svg?834d21ec";